export class LanguageResponse {
  language: Language;
  description: string;
  default: boolean;
}

export enum Language {
  CATALAN = 'ca',
  SPANISH = 'es',
  ENGLISH = 'en',
  PORTUGUESE = 'pt',
}

export class CustomdataResponse {
  b64ImageData: string;
  customText: string;
}

export class SpConfigResponse {
  sharepoint_clientid: string;
  sharepoint_tenantid: string;
  sharepoint_uri_authtentication: string;
}

export class LanguageInitialization {
  langList: Array<Language>;
  defaultLang: Language;
  userLang: Language;
}

export class CustomSnackBarData {
  icon: string;
  title: string;
  message: string;
}
